module.exports = __webpack_public_path__ + "img/maipu-logo-azul.a77e89b7.png";